export default __webpack_public_path__ + "static/media/prometheus.1c45395a438fd46a987aec779ba17863.svg";